/**
 * @file utils/lookup.js
 * Costruisce mappe di lookup indicizzate dal DataContext per ricerche O(1).
 * buildLookupMaps produce: risorseByCode, areeByCode, buByCode,
 * clientiByCode (key=tag_cliente), sediByCode, nwdByDate, deadlineByArea.
 */

export function buildLookupMaps(state) {
  return {
    risorseByCode:  buildMap(state.risorse,                  'id'),
    areeByCode:     buildMap(state.aree,                     'id'),
    buByCode:       buildMap(state.businessUnits,            'id'),
    clientiByCode:  buildMap(state.clienti,                  'tag_cliente'),
    sediByCode:     buildMap(state.sedi,                     'id'),
    nwdByDate:      buildNwdMap(state.nonWorkingDays),
    deadlineByArea: buildDeadlineMap(state.dateLimitePianificazioni),
  };
}

function buildMap(arr, keyField) {
  const map = {};
  for (const item of arr) map[item[keyField]] = item;
  return map;
}

function buildNwdMap(nonWorkingDays) {
  const map = {};
  for (const nwd of nonWorkingDays) map[nwd.data_non_lavorativa] = true;
  return map;
}

function buildDeadlineMap(deadlines) {
  const map = {};
  for (const dl of deadlines) {
    const key = `${dl.anno_pianificazione}-${String(dl.mese_pianificazione).padStart(2, '0')}`;
    map[key] = dl.data_limite;
  }
  return map;
}
